"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueuedJobsHandler = void 0;
class QueuedJobsHandler {
    attachErrorListener(onErrorListener) {
        this.onErrorListener = onErrorListener;
    }
}
exports.QueuedJobsHandler = QueuedJobsHandler;
//# sourceMappingURL=QueuedJobsHandler.js.map